export default {
    sso: process.env.VUE_APP_FEATURES_SSO === 'true'
}